module.exports = __webpack_public_path__ + "static/media/nextjs.7af5a20b.png";